import HttpFactory from '~/repository/factory';

export interface AuditQueryParams {
  userId?: string;
  action?: string;
  from?: string;
  to?: string;
  order?: 'asc' | 'desc';
  limit?: number;
  offset?: number;
}

export interface AuditItem {
  id: string;
  user_id: string;
  user_name: string | null;
  user_role: string | null;
  action: 'create' | 'update' | 'delete' | 'read';
  http_method: string | null;
  http_path: string | null;
  http_status: number | null;
  resource_type: string | null;
  resource_id: string | null;
  ip_address: string | null;
  correlation_id: string | null;
  created_at: string;
  request_body: Record<string, unknown> | null;
  changes: Record<string, { old: unknown; new: unknown }> | null;
}

export interface AuditQueryResponse {
  items: AuditItem[];
  total: number;
}

class AuditModule extends HttpFactory {
  private RESOURCE = '/audit';

  async query(params: AuditQueryParams = {}): Promise<AuditQueryResponse> {
    // Remove chaves vazias/indefinidas para não poluir a query string.
    const query: Record<string, string> = {};
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null && value !== '') {
        query[key] = String(value);
      }
    }
    return this.get<AuditQueryResponse>(this.RESOURCE, { query });
  }
}

export default AuditModule;
